"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _StickyContainer = _interopRequireDefault(require("../common/StickyContainer"));

var _TabConfig = require("../../constants/TabConfig");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _colors = require("HubStyleTokens/colors");

var _urls = require("pricing-pages-unified-ui/utils/urls");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    text-align: left;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    display: block;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MobileMenuCategory = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "MobileTabs__MobileMenuCategory",
  componentId: "mp8dcb-0"
})(["font-weight:800;display:block;position:relative;overflow:hidden;font-size:0.85em;opacity:0.7;margin-top:1.37em;margin-bottom:0.15em;&:first-child{margin-top:0;}&::after{content:'';display:inline-block;background-color:", ";height:1px;position:absolute;top:50%;transform:translate(10px,-50%);width:100%;}"], _colors.OLAF);
var MobileMenuBody = (0, _styledComponents.default)(_UIDialogBody.default).withConfig({
  displayName: "MobileTabs__MobileMenuBody",
  componentId: "mp8dcb-1"
})(["background-color:#167186;background-image:linear-gradient(to top right,#167186,#167d7a);color:", ";&.pricing-mobile-menu-body{padding:3.4em 1.45em;}"], _colors.OLAF);

var MobileMenuBodyInner = _styledComponents.default.div.withConfig({
  displayName: "MobileTabs__MobileMenuBodyInner",
  componentId: "mp8dcb-2"
})(["display:flex;flex-direction:column;padding:40px 0;"]);

var MobileMenuLinkWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileTabs__MobileMenuLinkWrapper",
  componentId: "mp8dcb-3"
})(["position:relative;display:flex;margin:0 auto 1.57em 0;align-items:center;cursor:pointer;"]);

var MobileMenuLink = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "MobileTabs__MobileMenuLink",
  componentId: "mp8dcb-4"
})(["display:inline-block;font-size:1.57em;line-height:1.4;&[selected='true']{text-decoration:underline;}"]);
var MobileMenuCloseButton = (0, _styledComponents.default)(_UIDialogCloseButton.default).withConfig({
  displayName: "MobileTabs__MobileMenuCloseButton",
  componentId: "mp8dcb-5"
})(["transform:scale(0.6);right:34px;top:13px;"]);
var MobileMenuTriggers = (0, _styledComponents.default)(_StickyContainer.default).withConfig({
  displayName: "MobileTabs__MobileMenuTriggers",
  componentId: "mp8dcb-6"
})(["display:none;text-align:center;width:100%;cursor:pointer;background-color:#167186;background-image:linear-gradient(to top right,#167186,#167d7a);color:", ";font-size:1.6em;font-weight:100;padding:0.6em 2.4em 0.86em 0.7em;", " ", ""], _colors.OLAF, _responsiveBreakpoints.default.tablet(_templateObject()), _responsiveBreakpoints.default.phone(_templateObject2()));
var MobileMenuTriggerLink = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "MobileTabs__MobileMenuTriggerLink",
  componentId: "mp8dcb-7"
})(["display:block;"]);
var MobileMenuTriggerCategory = (0, _styledComponents.default)(_FormattedMessage.default).withConfig({
  displayName: "MobileTabs__MobileMenuTriggerCategory",
  componentId: "mp8dcb-8"
})(["font-size:0.515em;letter-spacing:0.5px;margin-bottom:0.515em;opacity:0.7;font-weight:600;"]);
var MobileMenuTriggerIcon = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "MobileTabs__MobileMenuTriggerIcon",
  componentId: "mp8dcb-9"
})(["transform:scale(0.45) translateY(-50%);position:absolute;right:0.06em;margin:0;top:50%;color:", ";"], _colors.OLAF);

var MobileTabs = function MobileTabs(_ref) {
  var selectedPrimaryTab = _ref.selectedPrimaryTab,
      selectedSecondaryTab = _ref.selectedSecondaryTab,
      isHSFXEligible = _ref.isHSFXEligible,
      discountBadgeKey = _ref.discountBadgeKey,
      history = _ref.history;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isModalVisible = _useState2[0],
      setModalVisibility = _useState2[1];

  var toggleModal = function toggleModal(isVisible) {
    return setModalVisibility(isVisible);
  };

  var selectedConfig = _TabConfig.TabConfig[selectedPrimaryTab].find(function (tab) {
    return tab.id === selectedSecondaryTab;
  });

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(MobileMenuTriggers, {
    onClick: (0, _partial.default)(toggleModal, true),
    className: "mobile-menu-tab-triggers"
  }, _react.default.createElement("div", null, _react.default.createElement(MobileMenuTriggerCategory, {
    message: selectedConfig.mobileCategory
  }), _react.default.createElement(MobileMenuTriggerLink, {
    message: selectedConfig.mobileKey,
    onClick: (0, _partial.default)(toggleModal, true)
  })), _react.default.createElement(MobileMenuTriggerIcon, {
    name: "down",
    size: "sm",
    color: _colors.OLAF
  })), isModalVisible && _react.default.createElement(_UIModal.default, null, _react.default.createElement(MobileMenuCloseButton, {
    onClick: (0, _partial.default)(toggleModal, false),
    size: "xl"
  }), _react.default.createElement(MobileMenuBody, {
    className: "pricing-mobile-menu-body"
  }, _react.default.createElement(MobileMenuBodyInner, null, _react.default.createElement(MobileMenuCategory, {
    message: "pricingPage.pages.products.tabTitle"
  }), _TabConfig.TabConfig[_TabConfig.TabEnum.PRODUCTS].map(function (tab) {
    return _react.default.createElement(MobileMenuLinkWrapper, {
      key: tab.id,
      onClick: (0, _partial.default)(_urls.tabsNavigateTo, {
        path: "/" + (tab.slug || tab.id),
        history: history
      })
    }, _react.default.createElement(MobileMenuLink, {
      selected: selectedSecondaryTab === tab.id,
      message: tab.mobileKey
    }), tab.mobileBadge && tab.mobileBadge());
  }), _react.default.createElement(MobileMenuCategory, {
    message: "pricingPage.productCategories.bundles"
  }), _TabConfig.TabConfig[_TabConfig.TabEnum.BUNDLE].map(function (tab) {
    return _react.default.createElement(MobileMenuLinkWrapper, {
      key: tab.id,
      onClick: (0, _partial.default)(_urls.tabsNavigateTo, {
        path: "/" + (tab.slug || tab.id),
        history: history
      })
    }, _react.default.createElement(MobileMenuLink, {
      selected: selectedSecondaryTab === tab.id,
      message: tab.mobileKey
    }), tab.mobileBadge && tab.mobileBadge({
      isHSFXEligible: isHSFXEligible,
      discountBadgeKey: discountBadgeKey
    }));
  })))));
};

var _default = MobileTabs;
exports.default = _default;
module.exports = exports.default;